import Spinner from '@wix/wix-vod-shared/src/widget/ui-components/loading-spinner/loading-spinner';
import styles from './mobile-spinner-overlay.styl';


const MobileSpinnerOverlay = () => (
  <div className={styles['spinner-container']}>
    <Spinner styleName="spinner" />
  </div>
);

export default MobileSpinnerOverlay;



// WEBPACK FOOTER //
// ./src/mobile/components/mobile-spinner-overlay/mobile-spinner-overlay.js